module.exports = __webpack_public_path__ + "img/top-3.5be7f1f.png";